export default __webpack_public_path__ + "static/media/noServicesRequested.d5cd3169.svg";